import { ChatProviderType } from '../../../domain/chat/models/ChatProviderType';
import { IProGPTProviderServices } from './interfaces/IProGPTProviderServices';
import { ProGPTChatMessagesService } from './services/ProGPTChatMessagesService';
import { ProGPTChatSessionWriteService } from './services/ProGPTChatSessionWriteService';
import { ProGPTChatSessionsService } from './services/ProGPTChatSessionsService';
import { ProGPTDocumentsService } from './services/ProGPTDocumentsService';
import { ProGPTSettingsService } from './services/ProGPTSettingsService';
import { ProGPTUserService } from './services/ProGPTUserService';
import { ProGPTChatPersonalizationService } from './services/ProGPTChatPersonalizationService';

export class ProGPTProviderServices implements IProGPTProviderServices {
    public readonly providerType = ChatProviderType.ProGPT;
    public readonly sessions: ProGPTChatSessionsService;
    public readonly messages: ProGPTChatMessagesService;
    public readonly sessionWrite: ProGPTChatSessionWriteService;
    public readonly documents: ProGPTDocumentsService;
    public readonly settings: ProGPTSettingsService;
    public readonly users: ProGPTUserService;
    public readonly personalization: ProGPTChatPersonalizationService;

    constructor(baseUrl: string) {
        this.sessions = new ProGPTChatSessionsService(baseUrl);
        this.messages = new ProGPTChatMessagesService(baseUrl);
        this.sessionWrite = new ProGPTChatSessionWriteService(baseUrl);
        this.documents = new ProGPTDocumentsService(baseUrl);
        this.settings = new ProGPTSettingsService(baseUrl);
        this.users = new ProGPTUserService(baseUrl);
        this.personalization = new ProGPTChatPersonalizationService(baseUrl);
    }
}
